<!-- eslint-disable @typescript-eslint/ban-types -->
<template>
  <div class="modal-container">
    <div class="dialog-mask outside-clicker"></div>
    <div class="message-box">
      <q-card
        class="dialog-content"
        :style="{
          'max-width': maxsize + 'px',
          'max-height': maxheight + 'px',
          'min-width': minsize + 'px'
        }"
      >
        <q-card-section class="dialog-top">
          <div class="text-h6">{{ title }}</div>
        </q-card-section>

        <q-separator />

        <q-card-section class="scroll">
          <slot></slot>
        </q-card-section>
        <q-card-actions :align="actionsAlign" class="dialog-bottom">
          <slot name="footer"></slot>
        </q-card-actions>
      </q-card>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Emit } from "vue-property-decorator";

export default class App extends Vue {
  @Prop({ default: "" })
  title!: string;
  @Prop({ default: 767 })
  breakpoint!: number;
  @Prop({ default: 1024, type: [Number, String] })
  maxsize!: number;
  @Prop({ default: 300, type: [Number, String] })
  minsize!: number;
  @Prop({ type: [Number, String] })
  maxheight!: number;
  @Prop({ default: false })
  overlay!: boolean;
  @Prop()
  urlpath!: string;
  @Prop({ default: "right" })
  actionsAlign!: "left" | "center" | "right" | "between" | "around" | "stretch";
  @Prop({ default: null })
  escapeCallback!: () => void;
  @Prop({ default: null })
  enterCallback!: () => void;

  @Emit("close")
  escapePressed() {
    return false;
  }

  @Emit("onShortcutSave")
  onShortcutSave() {
    return false;
  }

  showDialog() {
    const scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
    const body = document.body;
    body.style.position = "fixed";
    body.style.top = `-${scrollY}`;
  }
  closeDialog() {
    const body = document.body;
    const scrollY = body.style.top;
    body.style.position = "";
    body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }

  created() {
    this.showDialog();
    history.pushState(null, document.title, location.href);
    history.back();
    history.forward();
    window.addEventListener("popstate", this.historypushState);

    // Der bruges window.addEventListener da for mange komponenter bruger og overskriver
    // v-on:key. Den kan også skrives om til at være mere dynamisk, men vi har ikke flere
    // usecases end disse.
    window.addEventListener("keydown", this.handleKeyEvents);
  }

  handleKeyEvents(event) {
    if (event.key === "Escape") {
      this.escapePressed();
    }

    if (event.key === "s" && (event.ctrlKey || event.metaKey)) {
      event.preventDefault(); // present "Save Page" from getting triggered.
      this.onShortcutSave();
    }
  }

  beforeUnmount() {
    this.closeDialog();
    window.removeEventListener("keydown", this.handleKeyEvents);
    window.removeEventListener("popstate", this.historypushState);
    history.back();
  }

  historypushState() {
    history.pushState(null, document.title, location.href);
  }
}
</script>

<style scoped lang="scss">
@import "../assets/variables";

.scroll {
  background-color: #f5f5f5;
  z-index: 0;
}

.modal-container {
  z-index: 5010;

  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.message-box {
  min-width: 240px;
  z-index: 5010;
}

.dialog-mask {
  z-index: 5009;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.33);
}

.dialog-content {
  max-width: 90%;
  margin: 0 20px;
  padding: 0;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
  -ms-flex-align: left;
  align-items: left;
  -ms-flex-pack: left;
  justify-content: left;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  color: #303133;
  overflow: auto;
  max-height: 90vh;
}

@media (max-width: 500px) {
  .dialog-content {
    max-height: 92vh;
    margin: 0;
  }

  .message-box {
    height: -webkit-fill-available;
  }
}

.dialog-content header {
  margin: 10px 0 26px;
  font-size: 18px;
  font-weight: 700;
}

.dialog-content .el-button,
.dialog-content p {
  font-size: inherit;
}

.dialog-content p {
  white-space: pre-wrap;
}

.dialog-content .el-button {
  -ms-flex: 1;
  flex: 1;
  border: 0;
  color: #409eff;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.dialog-content footer {
  display: -ms-flexbox;
  display: flex;
  margin-top: 24px;
}
.dialog-bottom {
  position: sticky;
  bottom: 0;
  left: 0;
  min-height: 55px;
  background-color: #fff;
  border-top: 1px solid #ddd;
  overflow: hidden;
}
.dialog-top {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
}
.dialogfooter {
  min-height: 55px;
}
</style>
